/**
 * Runtime configuration.
 *
 * Backend identifiers are NOT baked in at build time. CDK writes /config.json at
 * deploy time from resolved tokens, and the app fetches it before rendering. That is
 * what removes the manual copy-paste step, and it means the same immutable JS bundle
 * promotes across environments unchanged.
 */
export interface AppConfig {
  region: string;
  userPoolId: string;
  userPoolClientId: string;
  apiUrl: string;
  env: string;
}

let cached: AppConfig | undefined;

export async function loadConfig(): Promise<AppConfig> {
  if (cached) return cached;
  const response = await fetch('/config.json', { cache: 'no-store' });
  if (!response.ok) {
    throw new Error(`Could not load /config.json (${String(response.status)})`);
  }
  cached = (await response.json()) as AppConfig;
  return cached;
}
